const decimalNumberPattern = /^[+-]?(?:\d+\.\d+|\d+\.\d*|\.\d+)(?:e[+-]?\d+)?$/i

export function formatDecimalSeparator(value: unknown): unknown {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? String(value).replace('.', ',') : value
  }

  if (typeof value === 'string') {
    const trimmedValue = value.trim()
    if (decimalNumberPattern.test(trimmedValue)) {
      return value.replace('.', ',')
    }
  }

  return value
}
